// 阿塞拜疆
module.exports = {
  common: {
    edit: "redaktə",
    apply: "Müraciət et",
    activate: "aktivləşdirmə",
    delete: "sil",
    cancel: "Ləğv et",
    success: "uğur",
    fail: "uğursuz",
    save: "yadda saxla",
    ensure: "Əlbəttə",
    submit: "təqdim",
    remark: "Qeyd",
    detail: "Yoxlama",
    action: "işləmək",
    open: "açıq",
    close: "bağlama",
    back: "qayıt",
    export: "ixrac",
    modify: "Yenidən nəzərdən keçirin",
    layout: "çıxış",
    noListData: "Siyahıda məlumat yoxdur",
    more: "Təfərrüatlar",
    add: "Əlavə et",
    delSuccess: "uğurla silindi!",
    addFailure: "əlavə alınmadı!",
    logOut: "çıxış",
    delAllInfo: "Silinmə əməliyyatına davam etmək istəyirsiniz?",
    saveTip:
      "Səhifənin məzmununu saxlamamısınız, tərk etməyə davam etmək istəyirsiniz?",
    tip: "işarə",
    yes: "bəli",
    no: "yox",
    delTip: "Aktivləşdirmək üçün yoxlayın",
    batchDelete: "toplu silmə",
    search: "Soruşun",
    permission: "Hələ icazə yoxdur, xahiş edirəm geri qayıdın",
    reset: "sıfırla",
  },
  breadcrumbItem: {
    home: "Ad Siyahısı Konfiqurasiyası",
    data: "Cihazın ümumi konfiqurasiya qablaşdırması",
    alarm: "Zona Konfiqurasiyası",
    house: "Ev planının konfiqurasiyası",
    name: "Ad Siyahısı Konfiqurasiyası",
  },
  errorRes: {
    res82: "Sistem məşğuldur, daha sonra yenidən cəhd edin",
  },
  openConfig: {
    title: "Cihazın Ümumi Konfiqurasiyası",
    version: "Protokol versiyası",
    versionTip: "Lütfən, protokol versiyasını seçin",
    checkVersion: "Protokol versiyası boş ola bilməz, yenidən seçin",
    signType: "İmza alqoritmi növü",
    checkSignType: "İmza alqoritmi növü boş ola bilməz, yenidən seçin",
    fileLabel: "Sənəd seçin",
    addFile: "faylları əlavə et",
    fileName: "fayl adı",
    zipType: "Sıxılma üsulu",
    noZip: "kompressiya yoxdur",
    noFile: "Hələ heç bir fayl əlavə edilməyib",
    checkFile: "Konfiqurasiya faylı boşdur, lütfən, fayl əlavə edin",
    name: "ad",
    nameTip: "Giriş uzunluğu 1-10 rəqəmdir",
    checkName: "Ad boş ola bilməz, yenidən daxil edin",
    checkName1: "Yanlış ad daxil edin, yenidən daxil edin",
    room: "cihaz identifikatoru",
    roomTip: "Giriş uzunluğu 1-24 bitdir və səviyyə - ilə fərqlənir",
    checkRoom: "Cihaz nömrəsi boş ola bilməz, yenidən daxil edin",
    checkRoom1: "Cihaz nömrəsinin daxil edilməsi səhvdir, yenidən daxil edin",
    pic: "şəkil",
    add: "Əlavə etmək",
    reset: "sıfırla",
    picTip: "Şəkil faylının maksimum yükləmə ölçüsü 3 m-dir",
    checkPic: "Şəkil faylı boş ola bilməz, lütfən, yenidən seçin",
    imgRegTip: "Yalnız jpg, jpeg, png formatlarında faylları yükləyin",
    excRegTip: "Yalnız xls və xlsx formatında faylları yükləyin",
    zipRegTip: "Yalnız zip formatında faylları yükləyin",
    produce: "Konfiqurasiya faylını yaradın",
    confType: "Konfiqurasiya növü",
    pack: "Paket",
    batchAdd: "Paket əlavə et",
    singleAdd: "Tək əlavə",
    modelBatch: "Paket idxal şablonunu yükləyin",
    uploadInfo: "Excel əsas məlumatları yükləyin",
    uploadPic: "Şəkil paketini Zip yükləyin",
    addName: "Tək bir məlumat əlavə edin",
    sameTip: "Serial nömrəsi:",
    sameTip1: "Cihaz nömrəsinin dublikatı",
    modelError:
      "Yüklənmiş əsas məlumat faylının məzmunu yanlışdır, lütfən, şablona uyğun olaraq faylı dəyişdirin",
    noPic:
      "Siyahıda şəkillərlə əlavə olunmayan məlumatlar var, konfiqurasiya faylını yaratmazdan əvvəl şəkilləri tamamlamalısınız",
    picBtnTip: "Əvvəlcə əsas məlumat faylını yükləyin",
    devType: "Avadanlıq növü",
    devTypeTip: "Lütfən, cihaz növünü seçin",
    checkDevType: "Cihaz növü boş ola bilməz, yenidən seçin",
    indexName: "seriya nömrəsi",
    IS: "Daxili blok",
    GU: "İdarəetmə maşını",
    OS1: "Səs stansiyası",
    OS2: "Divar maşını",
    OS3: "Kiçik Qapılı Stansiya",
    nameListTip:
      "Yüklənmiş əsas məlumatda natamam ad sahəsi olan məlumatlar var və düzgün məlumatların qalan hissəsi idxal edilib",
    numListTip:
      "Yüklənmiş əsas məlumatda, cihazın nömrəsi sahəsində natamam məlumat var və düzgün məlumatların qalan hissəsi idxal edilib",
  },
  alarm: {
    ad: "AD zonası",
    io: "IO zonası",
    alarmPlus: "Zona genişləndirilməsi",
    num: "seriya nömrəsi",
    open: "açıq",
    close: "yaxın",
    machine: "Detektor növü",
    sendType: "Tetik növü",
    mode: "model",
    mType1: "infraqırmızı",
    mType2: "Qapı maqniti",
    mType3: "pəncərə maqniti",
    mType4: "qaz",
    mType5: "tüstü",
    mType6: "qapı zəngi",
    mType7: "Xəbər bülleteni düyməsi",
    mType8: "İnfraqırmızı Qapı Sensoru",
    mType9: "Əl siqnalizasiya qapı sensoru",
    mType10: "vibrasiya",
    mType11: "hava təzyiqi",
    mType12: "digər",
    send1: "24 saat ərzində dərhal məlumat verin",
    send2: "Gecikmiş həyəcan",
    send3: "Köçürmə gecikməsi",
    send4: "Dərhal polisə zəng edin",
    send5: "Çapraz həyəcan",
    mode1: "Normal olaraq açıq",
    mode2: "Tez-tez söndürülür",
    presence: "evdə",
    leaving: "evdən çıxmaq",
    timeSet: "Qola bağlı vaxt təyini",
    delayTime: "Effektiv gecikmənin silahlanması (saniyələr)",
    startDelay: "Siqnalın işə salınma gecikməsi (saniyə)",
    startUtil: "Siqnalın müddəti (dəqiqə)",
    associated: "Əlaqəli Zona",
  },
  house: {
    dev: "avadanlıq",
    scene: "Səhnələr",
    vine: "sensor",
    single: "Səhnələrə müstəqil nəzarət",
    light: "işıq",
    air: "Kondisioner",
    heat: "Döşəmə isitmə",
    fresh: "Təzə külək",
    switch: "Keçir rozetkası",
    curtain: "pərdə",
    water: "su qızdırıcısı",
    bgm: "Fon musiqisi",
    cust: "Fərdi Cihaz",
    slight: "işıq",
    sAir: "Kondisioner",
    sHeat: "Döşəmə isitmə",
    sFresh: "Təzə külək",
    sSwitch: "Keçir rozetkası",
    sCurtain: "pərdə",
    sWater: "su qızdırıcısı",
    sBgm: "Fon musiqisi",
    sCust: "Fərdi Cihaz",
    IndependentControl: "Səhnələrə müstəqil nəzarət",
    scene1: "1-ci səhnə",
    scene2: "Səhnə 2",
    scene3: "Səhnə 3",
    scene4: "Səhnə 4",
    scene5: "Səhnə 5",
    scene6: "Səhnə 6",
    scene7: "Səhnə 7",
    scene8: "Səhnə 8",
    temp1: "temperatur",
    temp2: "rütubət",
    temp3: "metan",
    temp4: "üzvi qaz",
    picTip: "Mərtəbə planı yoxdur",
    upload: "Mərtəbə planını yükləyin",
    imgSize: "Bir mərtəbə planının təsvir ölçüsü 10M-dən çox olmamalıdır",
    imgName:
      "Yüklənmiş mərtəbə planı faylının adı Çin dilində görünməməlidir, lütfən, yenidən seçin",
    imgLength:
      "Mərtəbə planı yükləmələrinin və əlavələrinin ümumi sayı 8-dən çox olmamalıdır və qovluqdakı ilk 8 şəkil avtomatik olaraq seçilmişdir",
    imgCheckTip: "Mərtəbə planı uyğun gəlmir, lütfən, yenidən yükləyin",
    room1: "Ev Tipi 1",
    room2: "Ev Tipi 2",
    room3: "Ev Tipi 3",
    room4: "Ev Tipi 4",
    room5: "Ev Tipi 5",
    room6: "Ev Tipi 6",
    room7: "Ev Tipi 7",
    room8: "Ev Tipi Şəkil 8",
    download: "ixrac",
    input: "İdxal konfiqurasiyası",
    title: "Avadanlıq parametrləri cədvəli",
    name: "ad",
    location: "Yer",
    start: "başlamaq",
    see: "görünən",
    noSee: "Görünməz",
    belong: "məxsusdur",
    bgIcon: "Mavi Boz İkonu",
    vineTip:
      "Temperaturun tənzimlənməsi xüsusiyyətlərini təyin etməzdən əvvəl mərtəbə planını seçin",
    sceneTip:
      "Zəhmət olmasa mərtəbə planını seçin və sonra səhnə xüsusiyyətlərini təyin edin",
    dragTip:
      "Lütfən, sürükləmə əməliyyatını yerinə yetirməzdən əvvəl mərtəbə planını seçin",
    editTip: "Uğurla redaktə edildi",
    addTip: "Yükləyərkən bütün mərtəbə planlarını bir anda seçməlisiniz",
    editError: "Lütfən redaktə etməzdən əvvəl redaktə məzmununu göstərin",
    delError: "Silmədən əvvəl silinəcək məzmunu qeyd edin",
    delTip: "uğurla silindi",
    imgAddTip:
      "Yüklənmiş və əlavə edilmiş mərtəbə planlarının ümumi sayı 8-ə çatdı və daha çox əlavə edilə bilməz",
    houseTitle: "Ev tipi xəritəsinin dəyişdirilməsi:",
    delHouseTip:
      "Bu əməliyyat mərtəbə planını və konfiqurasiya məzmununu siləcək. Davam etmək istəyirsiniz?",
    sendTip:
      "Yenidən dəyişdirmək üçün konfiqurasiya məzmununu idxal edin, xml faylını yükləyə bilərsiniz",
    checkType:
      "Yüklənmiş faylın formatı səhvdir, lütfən, faylın məzmununu yoxlayın və yenidən yükləyin",
    importTip: "Konfiqurasiya faylını idxal et",
    importTip1: "Müvafiq mərtəbə planını idxal edin",
    upLoadBtn: "Yükləmək",
    picContent:
      "Mərtəbə planlarının yüklənməsi qaydası konfiqurasiya faylındakı mərtəbə planlarının sırasına uyğun olmalıdır",
    successFile: "Konfiqurasiya faylı uğurla yükləndi",
    vineTipCheck: "Ad boş ola bilməz, girişi təsdiqləyin",
    picNumMax:
      "İdxal edilmiş şəkillərin sayını təsdiqləyin. İdxal edilmiş şəkillərin cari sayı konfiqurasiya faylındakı ev planlarının sayından çoxdur. Lütfən, yenidən seçin",
    picNumMin:
      "İdxal edilmiş şəkillərin sayını təsdiqləyin. İdxal edilmiş şəkillərin cari sayı konfiqurasiya faylındakı ev planlarının sayından azdır. Lütfən, yenidən seçin",
    maxSizeTip:
      "Bu növ əlavələrin sayı və ya ümumi sayı limiti keçir. Əlavə etmək lazımdırsa, lütfən, əvvəlcə əlavə edilmiş cihazları və ya səhnələri sıralayın.",
    devNameTip: "Zəhmət olmasa ad daxil edin",
    chromeTip: "Chrome brauzeri tövsiyə olunur",
    downTip: "Yükləmə linkinə keçmək üçün klikləyin",
    imgRegTip: "Yalnız jpg və jpeg formatında faylları yükləyin",
    threeTitle: "Üç sabit sistem",
    mainControl: "usta",
    sedControl: "alt nəzarət",
    controlBtn: "Konfiqurasiya",
    configEdit: "Sanheng sistem konfiqurasiya təfərrüatları",
    moveTip: "Lütfən, nişanı mərtəbə planı sahəsinə dartın, yenidən dartın",
    repeatNameTip:
      "Eyni adlı mərtəbə planlarını yükləmək mümkün deyil, yenidən seçin",
    space: "(Ehtiyatdadır)",
  },
  updateConfig: {
    tip0: "24 saatlıq siqnalizasiya qurarkən açarı ON vəziyyətinə qoyun",
    tip1: "24 saatlıq həyəcan siqnalını qurarkən açarı yandırmaq lazımdır",
    tip2: "Dərhal həyəcan siqnalı qurarkən, keçid yandırılmalıdır",
    tip3: "Gecikmə siqnalı söndürüldükdə, çatdırılma gecikməsi söndürülməlidir",
    tip4: "Çarmıx həyəcan quruldu, əlaqəli əməliyyat lazımdır",
    tip5: "Lütfən, əvvəlcə gecikmə siqnalını yandırın",
    tip6: "Dərhal həyəcan siqnalı təyin edərkən açarı yandırın",
  },
  audio: {
    title: "Səs Təklif Paketləmə Aləti",
    lock: "Açılış səsi təklif olunur",
    call: "Çağırma səsi təklif olunur",
    speak: "Danışma səsi təklif olunur",
    busy: "Məşğul səsi təklif olunur",
    tip1: ".wav formatlı faylı yükləmək üçün klikləyin",
    tip2: "Fayl ölçüsü 1M-dən çox olmamalıdır",
    tip3: ".wav formatlı faylı yükləyin",
    tip4: "Bütün faylları yükləyin, xahiş olunur",
    add: "Fayllar yaradın",
  },
  threeProject: {
    hotWater: "Isıqlı su sistemi",
    cho: "Formaldehid",
    config: "Yerləşdirmək",
    unconfig: "Yerləşdirməmək",
  },
  elevator: {
    title: "Qaldırım nəzarət konfiqurasiyası generatoru",
    label: "Qaldırım nəzarət konfiqurasiya cədvəlini yüklə",
    uploadTip: "Yükləmək üçün faylı buraya kliklə və ya sürüklə",
    upload: "Yüklə",
    download: "Şablonu yüklə",
    downloadTip:
      "Qaldırım nəzarət konfiqurasiya şablonunu yükləmək üçün kliklə",
    error1:
      "[Fiziki mərtəbə] səhvdir. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    error2:
      "[Görünən mərtəbə] səhvdir. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    error3:
      "[Qaldırım nəzarət şлюzi ünvanı] səhvdir. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    error4:
      "[Qaldırım nömrəsi görüntülənməsi] səhvdir. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    error5:
      "[Cihaz IP] səhvdir. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    error6:
      "[Qaldırım nəzarət şlüzu] sayı limiti keçib. Konfiqurasiya faylını yoxlayın və yenidən daxil edin.",
    generate: "Qaldırım nəzarət konfiqurasiya şablonu",
    fileLabel: "Qaldırım nəzarət konfiqurasiya faylı:",
    tip: "Konfiqurasiya faylını, cihaza daxil etmək üçün [Resursların yenilənməsi] bölməsindəki PC alətinə yerləşdirin.",
    downloadfile: "Yüklə",
    fileName: "QaldırımNəzarətKonfiqurasiyası.xlsx",
    formatError:
      "Yüklənmiş faylın formatı səhvdir, fayl məzmununu yoxlayın və yenidən yükləyin",
  },
};
